import currencyFormatter from "currency-formatter";
import { store } from "../../../source/index";
import { _Api } from '../../api/_call';
import {
    updateTotalCounts,
} from '../../../source/app/appSlice';
// export const toFormatPrice = (amount, args = {}, customcurrency) => {
//     if (amount === null || amount === undefined) {
//         return 0;
//     }
//     var state = store.getState();
//     var OrgSettings = state?.app?.organisation_settings;
//     var price_format_options = OrgSettings?.price_format;
//     var currency = customcurrency ? customcurrency : price_format_options?.currency || "USD";
//     var decimal_point = price_format_options?.decimal_point || 2;
//     var thousand_separator = price_format_options?.thousand_separator || ",";
//     var decimal_separator = '.';
//     if (thousand_separator.search(".")) {
//         decimal_separator = ",";
//     }
//     if (thousand_separator === ".") {
//         let amountString = amount?.toString();
//         let formattedAmount = amountString?.replace(/\.00$/, '');
//         amount = formattedAmount?.replace(/\./g, '');
//     }
//     var options = {
//         code: currency,
//         decimal: decimal_separator,
//         thousand: thousand_separator,
//         precision: decimal_point,
//         format: '%v'
//     }

//     if (args.addSymbol) {
//         options.format = '%s %v';

//         if (currency === "AED") {
//             options.format = '%v %s';
//             options.symbol = "AED";
//         }
//     }
//     amount = currencyFormatter.format(amount, options);
//     return amount;
// }

export const toFormatPrice = (amount, args = {}, customcurrency) => {

    if (amount === null || amount === undefined || amount === "" || amount === 0) {
        return 0.00; // Default formatted value
    }

    var state = store.getState();
    var OrgSettings = state?.app?.organisation_settings;
    var price_format_options = OrgSettings?.price_format;
    var currency = customcurrency ? customcurrency : price_format_options?.currency || "USD";
    var thousand_separator = price_format_options?.thousand_separator || ",";
    var decimal_point = price_format_options?.decimal_point || 2;
    if (thousand_separator === ".") {
        amount = currencyFormatter.unformat(amount, { locale: 'nl-NL' });
        amount = parseFloat(amount.toFixed(decimal_point));
    } else if (thousand_separator === ",") {
        amount = currencyFormatter.unformat(amount, { locale: 'en-US' });
        amount = parseFloat(amount.toFixed(decimal_point));
    } else if (currency === "INR") {
        amount = currencyFormatter.unformat(amount, { locale: 'en-IN' });
        amount = parseFloat(amount.toFixed(decimal_point));
    }

    if (args.addSymbol) {
        return Intl.NumberFormat(thousand_separator === "." ? 'nl-NL' : 'en-US', {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'narrowSymbol'
        }).format(amount);
    } else {
        return Intl.NumberFormat(thousand_separator === "." ? 'nl-NL' : 'en-US').format(amount);
    }


}

export const toUnformatPrice = (amount, args = {}) => {
    var state = store.getState();
    var OrgSettings = state?.app?.organisation_settings;
    var price_format_options = OrgSettings?.price_format;
    var currency = price_format_options?.currency || "USD";
    // var show_amount_in = price_format_options?.show_amount_in || "Million";
    var thousand_separator = price_format_options?.thousand_separator || ",";
    var decimal_point = price_format_options?.decimal_point || 2;
    if (thousand_separator === ".") {
        amount = currencyFormatter.unformat(amount, { locale: 'nl-NL' });
        amount = parseFloat(amount.toFixed(decimal_point));
    } else if (thousand_separator === ",") {
        amount = currencyFormatter.unformat(amount, { locale: 'en-US' });
        amount = parseFloat(amount.toFixed(decimal_point));

    } else if (currency === "INR") {
        amount = currencyFormatter.unformat(amount, { locale: 'en-IN' });
        amount = parseFloat(amount.toFixed(decimal_point));
    }

    return amount;
}







// export const toUnformatPrice = (amount, args = {}) => {
//     if (amount === null || amount === undefined) {
//         return 0;
//     }
//     var state = store.getState();
//     var OrgSettings = state?.app?.organisation_settings;
//     var price_format_options = OrgSettings?.price_format;
//     var currency = price_format_options?.currency || "USD";
//     var decimal_point = price_format_options?.decimal_point || 2;
//     var thousand_separator = price_format_options?.thousand_separator || ",";
//     var decimal_separator = '.';
//     if (thousand_separator.search(".")) {
//         decimal_separator = ",";
//     }
//     if (thousand_separator === ".") {
//         let amountString = amount?.toString();
//         let formattedAmount = amountString?.replace(/\.00$/, '');
//         amount = formattedAmount?.replace(/\./g, '');
//     }

//     var options = {
//         code: currency,
//         decimal: decimal_separator,
//         thousand: thousand_separator,
//         precision: decimal_point,
//         format: '%v'
//     }
//     if (args.addSymbol) {
//         options.format = '%s %v';
//     }
//     amount = currencyFormatter.unformat(amount, options);
//     return amount;
// }

export const numberFormatter = (amount) => {
    if (amount === null || amount === undefined) {
        return 0; // Return 0 if the amount is invalid
    }
    var state = store.getState();
    var OrgSettings = state?.app?.organisation_settings;
    var price_format_options = OrgSettings?.price_format;
    const decimal_point = Number(price_format_options?.decimal_point) || 2;
    const num = Number(amount);
    if (!Number.isFinite(num)) {
        return 0;
    }

    const factor = Math.pow(10, decimal_point);
    // num * factor can land just under the intended value (e.g. 2.03 * 100 === 202.99999999999997),
    // which Math.trunc would then chop down to the wrong number. Rounding off that float noise first
    // (well within decimal_point precision) keeps this a truncation, not a round, of the real value.
    const scaled = Number((num * factor).toFixed(6));
    const truncated = Math.trunc(scaled) / factor;
    return truncated.toFixed(decimal_point);
};


export const buildTodayDateRange = () => {
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);
    return { filter: [todayStart, todayEnd], label: 'Today' };
};

/** Rolling ~1 month window ending today (matches existing PO/transaction tab default). */
export const buildLastMonthDateRange = () => {
    const prevMonth = new Date();
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    prevMonth.setHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);
    return { filter: [prevMonth, todayEnd], label: 'LastMonth' };
};

export const buildStatusDateMapFromState = (datesMap = {}) => {
    const map = {};
    Object.entries(datesMap).forEach(([key, value]) => {
        map[key] = {
            start_date: value?.filter?.[0] || '',
            end_date: value?.filter?.[1] || '',
        };
    });
    return map;
};

const toDayKey = (value) => {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

const toRangeKey = (startDate, endDate) => `${toDayKey(startDate)}|${toDayKey(endDate)}`;

const totalsInFlight = new Map();
const totalsCache = new Map();
const TOTALS_CACHE_MS = 10000;

export const transactionTotals = async ({
    start_date = '',
    end_date = '',
    statusDateMap,
} = {}) => {
    try {
        let rangeStart = start_date;
        let rangeEnd = end_date;
        if ((!rangeStart || !rangeEnd) && statusDateMap && typeof statusDateMap === 'object') {
            const first = Object.values(statusDateMap).find((range) => range?.start_date && range?.end_date);
            if (first) {
                rangeStart = first.start_date;
                rangeEnd = first.end_date;
            }
        }

        const key = toRangeKey(rangeStart, rangeEnd);
        const cached = totalsCache.get(key);
        if (cached && Date.now() - cached.at < TOTALS_CACHE_MS) {
            if (cached.data) store.dispatch(updateTotalCounts(cached.data));
            return;
        }
        if (totalsInFlight.has(key)) {
            const data = await totalsInFlight.get(key);
            if (data) store.dispatch(updateTotalCounts(data));
            return;
        }

        const request = (async () => {
            try {
                const countdata = await _Api(
                    {
                        start_date: rangeStart ? rangeStart : '',
                        end_date: rangeEnd ? rangeEnd : '',
                    },
                    `api/v1/Inventory/common/transactionTotals`
                );
                const data = countdata?.code === 200 ? countdata?.data : null;
                totalsCache.set(key, { data, at: Date.now() });
                return data;
            } finally {
                totalsInFlight.delete(key);
            }
        })();

        totalsInFlight.set(key, request);
        const data = await request;
        if (data) {
            store.dispatch(updateTotalCounts(data));
        }
    } catch (err) {
        console.log(err, "err");
    }
}
